import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4be423c7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "p" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p footnote" }, " Peace, Love, Unity, Respect 🫶 ", -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, [
      _createTextVNode(" Built with ♡ by zk-phi "),
      _createVNode(_component_Button, {
        type: "text",
        onClick: _ctx.donation
      }, {
        default: _withCtx(() => [
          _createTextVNode(" ライセンス ")
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["onClick"]),
      _createCommentVNode("      /"),
      _createCommentVNode("      <Button type=\"text\" @click=\"backstage\">"),
      _createCommentVNode("        <template #icon>"),
      _createCommentVNode("          🛠"),
      _createCommentVNode("        </template>"),
      _createCommentVNode("        開発室"),
      _createCommentVNode("      </Button>"),
      _createCommentVNode("      /"),
      _createCommentVNode("      <Button type=\"text\" @click=\"share\">"),
      _createCommentVNode("        <template #icon>"),
      _createCommentVNode("          🤝"),
      _createCommentVNode("        </template>"),
      _createCommentVNode("        Xでシェア"),
      _createCommentVNode("      </Button>")
    ]),
    _createCommentVNode("    <p class=\"p\">"),
    _createCommentVNode("      このページでは Cookie (アクセス数などの集計に Google Analytics、エラーの検知に Rollbar) を使用しています。"),
    _createCommentVNode("    </p>"),
    _hoisted_3
  ]))
}